module.exports = __webpack_public_path__ + "img/online-tutor-400x300.b7dc3936.jpg";